module.exports = __webpack_public_path__ + "img/img-1.abeb200c.svg";